import React from 'react'
import Index from '../_components/UserManagement/Index'

function UserManagement() {
  return (
    <Index />
  )
}

export default UserManagement;